// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jx7K","content":"styles_content__1ZA9e","brand_v2":"styles_brand_v2__6Akjb","light":"styles_light__1RXXJ","overlayContent":"styles_overlayContent__3Efbr"};